import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {BookingIcon} from "./booking-icon.pipe";

@NgModule({
    declarations: [
        BookingIcon
    ],
    exports: [
        BookingIcon
    ],
    imports: [
        CommonModule
    ]
})
export class BookingIconModule {
}
